document.addEventListener('DOMContentLoaded', async function () {
  if (typeof Prism === 'undefined') {
    return;
  }

  const themeStorageKey = 'syntax-highlight-static-theme';
  const defaultThemeId = 'prism-okaidia';
  const featuredLanguageIds = [
    'markup',
    'css',
    'javascript',
    'json',
    'bash',
    'powershell',
    'python',
    'typescript',
    'jsx',
    'graphql',
    'yaml',
    'diff'
  ];

  const catalogUrl = '/asset/file/content/example/syntax-highlight-static/catalog.json';
  const featuredLanguagesTocId = 'syntax-highlight---static-via-prism-featured-languages';
  const fullCatalogTocId = 'syntax-highlight---static-via-prism-full-language-catalog';
  const genericLanguageSamples = new Set([
    'enabled = true\nmode = full\nlabel = demo',
    'const demo = (value) => value?.trim() ?? "fallback";\nconsole.log(demo(" Prism "));',
    'for (int i = 0; i < 3; i++) {\n  printf("Prism demo\\n");\n}',
    'SELECT id, name\nFROM demo_items\nWHERE enabled = 1;',
    '# Prism Demo\n- static example\n- full catalog'
  ]);
  const languageSampleOverrides = {
    abap: 'DATA lv_total TYPE i VALUE 3.\nWRITE: / |Prism demo total: { lv_total }|.',
    abnf: 'header = "Accept" ":" OWS media-range CRLF\nmedia-range = "text" "/" "html"\nOWS = *( SP / HTAB )',
    actionscript: 'const label:String = "Prism";\ntrace(label);',
    ada: 'procedure Demo is\nbegin\n  Put_Line("Prism demo");\nend Demo;',
    agda: 'module Demo where\nopen import Data.Nat\n\nincrement : Nat -> Nat\nincrement n = suc n',
    al: 'codeunit 50100 Demo\n{\n    trigger OnRun()\n    begin\n        Message(\'Prism demo\');\n    end;\n}',
    antlr4: 'grammar Demo;\nstart : HELLO name EOF;\nname : ID ;\nHELLO : \'hello\' ;\nID : [a-zA-Z]+ ;\nWS : [ \\t\\r\\n]+ -> skip ;',
    apl: 'items <- 1 2 3\n+/items',
    apex: 'public with sharing class DemoController {\n  public static Account loadAccount(Id accountId) {\n    Account account = [SELECT Id, Name FROM Account WHERE Id = :accountId LIMIT 1];\n    System.debug(account.Name);\n    return account;\n  }\n}',
    applescript: 'set demoLabel to "Prism"\ndisplay dialog demoLabel',
    aql: 'FOR item IN demoItems\n  FILTER item.enabled == true\n  RETURN item',
    arff: '@RELATION demo\n@ATTRIBUTE enabled {true,false}\n@DATA\ntrue',
    armasm: 'MOV R0, #1\nADD R1, R0, #2',
    arturo: 'label: "Prism"\nloop 3 [\n  print [label " demo"]\n]',
    asm6502: 'LDA #$01\nSTA $0200',
    asmatmel: 'ldi r16, 0x01\nout PORTB, r16',
    asciidoc: '= Prism Demo\n:toc:\n\n== Overview\n\n[source,js]\n----\nconsole.log("Prism demo");\n----',
    autohotkey: 'demo := "Prism"\nMsgBox, % demo',
    autoit: 'Local $demo = "Prism"\nConsoleWrite($demo & @CRLF)',
    avisynth: 'AviSource("demo.avi")\nConvertToYV12()\nLanczosResize(1280, 720)',
    'avro-idl': '@namespace("demo.prism")\nprotocol Demo {\n  record Item {\n    string label;\n  }\n}',
    awk: '/ERROR/ { print $1, $2 }\nEND { print NR " lines processed" }',
    basic: '10 PRINT "Prism demo"\n20 END',
    batch: '@echo off\necho Prism demo',
    bbcode: '[b]Prism[/b] [url=https://prismjs.com]docs[/url]',
    bbj: 'PRINT "Prism demo"',
    bicep: "param environment string = 'demo'\noutput label string = environment",
    birb: 'fun chirp() {\n  say "Prism demo";\n}',
    bison: '%token NUMBER\n%%\nexpr: NUMBER ;',
    bnf: '<demo> ::= "Prism" <space> "showcase"',
    brainfuck: '+++++[>++++++++<-]>+.',
    bqn: 'demo <- "Prism"\ncount demo',
    brightscript: 'sub Main()\n  print "Prism demo"\nend sub',
    bro: 'event zeek_init() {\n  print "Prism demo";\n}',
    bsl: 'Message("Prism demo");',
    cil: '.method public hidebysig static void Main() cil managed {\n  ldstr "Prism demo"\n  call void [mscorlib]System.Console::WriteLine(string)\n  ret\n}',
    clojure: '(println "Prism demo")',
    cmake: 'project(PrismDemo)\nadd_executable(demo main.cpp)',
    cobol: 'DISPLAY "PRISM DEMO".',
    coffeescript: 'demo = (value) -> value.trim()\nconsole.log demo " Prism "',
    concurnas: 'val demo = "Prism"\nprintln(demo)',
    csp: "default-src 'self';\nimg-src 'self' data:;",
    cooklang: '>> title: Prism demo\nmix flour',
    coq: 'Definition demo := 3.\nCheck demo.',
    crystal: 'demo = "Prism"\nputs demo',
    cue: 'demo: {\n  enabled: true\n  label: "Prism"\n}',
    cypher: 'MATCH (item:Demo {enabled: true})\nRETURN item.label',
    dataweave: '%dw 2.0\noutput application/json\n---\n{ label: "Prism" }',
    dax: 'Demo Count = COUNTROWS(\'Items\')',
    dhall: '{ enabled = True, label = "Prism" }',
    'dns-zone-file': '$ORIGIN example.com.\n@ IN A 192.0.2.1',
    dot: 'digraph Demo {\n  Prism -> Showcase;\n}',
    ebnf: 'demo = "Prism" , " " , "showcase" ;',
    eiffel: 'class DEMO\nfeature\n  make do\n    print ("Prism demo%N")\n  end\nend',
    elixir: 'IO.puts("Prism demo")',
    elm: 'module Demo exposing (main)\nmain = text "Prism"',
    erb: '<%= "Prism demo" %>',
    erlang: 'demo() -> io:format("Prism demo~n").',
    'excel-formula': '=SUM(A1:A3)',
    factor: '"Prism demo" print',
    false: '"Prism demo"[$.]?',
    fortran: 'print *, "Prism demo"\nend',
    fsharp: 'printfn "Prism demo"',
    'firestore-security-rules': 'rules_version = \'2\';\nservice cloud.firestore {\n  match /databases/{database}/documents {\n    match /demos/{demoId} {\n      allow read: if true;\n    }\n  }\n}',
    gap: 'Print("Prism demo\\n");',
    gcode: 'G21\nG1 X10 Y5 F1500',
    gdscript: 'func _ready():\n  print("Prism demo")',
    gedcom: '0 @I1@ INDI\n1 NAME Prism /Demo/',
    gettext: 'msgid "Prism demo"\nmsgstr "Prism demo"',
    gherkin: 'Feature: Prism demo\n  Scenario: Static page\n    Given the catalog loads',
    glsl: 'void main() {\n  gl_FragColor = vec4(1.0, 0.5, 0.0, 1.0);\n}',
    gn: 'executable("demo") {\n  sources = [ "main.cc" ]\n}',
    'go-module': 'module example.com/prism-demo\n\ngo 1.24.0',
    gradle: "plugins { id 'java' }\nversion = '1.0.0'",
    groovy: 'def demo = "Prism"\nprintln demo',
    haml: '%section.demo-card\n  %h2 Prism Demo',
    haskell: 'main = putStrLn "Prism demo"',
    haxe: 'class Demo {\n  static function main() trace("Prism demo");\n}',
    hcl: 'demo = {\n  enabled = true\n  label = "Prism"\n}',
    hlsl: 'float4 main() : SV_Target {\n  return float4(1, 0.5, 0, 1);\n}',
    hoon: ':-  %say\n"Prism demo"\n==',
    hpkp: 'Public-Key-Pins: pin-sha256="base64=="; max-age=5184000;',
    hsts: 'Strict-Transport-Security: max-age=63072000; includeSubDomains; preload',
    ichigojam: '10 PRINT "PRISM DEMO"',
    icon: 'write("Prism demo")',
    'icu-message-format': '{itemCount, plural, one {# demo} other {# demos}}',
    idris: 'main : IO ()\nmain = putStrLn "Prism demo"',
    ignore: 'node_modules/\ndist/\n.cache/',
    iecst: 'PROGRAM Demo\nVAR\n  Enabled : BOOL := TRUE;\nEND_VAR',
    ini: '[demo]\nenabled=true',
    io: '"Prism demo" println',
    java: 'for (int i = 0; i < 3; i++) {\n  System.out.println("Prism demo");\n}',
    javadoc: '/**\n * Builds the Prism demo label.\n * @param enabled whether static rendering is enabled\n * @return demo label text\n */',
    javadoclike: '/**\n * Demo language-agnostic documentation block.\n * @param label demo label value\n * @returns normalized label\n */',
    javastacktrace: 'Exception in thread "main" java.lang.IllegalStateException: Prism demo failed\n\tat com.example.Demo.render(Demo.java:27)\n\tat com.example.Demo.main(Demo.java:13)',
    jolie: 'main {\n  println@Console("Prism demo")();\n}',
    jq: '.items[] | .name',
    jsonp: 'callback({"label":"Prism demo"});',
    julia: 'println("Prism demo")',
    kusto: 'DemoTable | where Enabled == true | project Name',
    latex: '\\section{Prism Demo}\n\\textbf{Static showcase}',
    less: '.demo-card {\n  color: #f26d3d;\n}',
    linker: 'SECTIONS {\n  .text : { *(.text) }\n}',
    'linker-script': 'SECTIONS {\n  .text : { *(.text) }\n}',
    lisp: '(format t "Prism demo~%")',
    llvm: '%demo = add i32 1, 2',
    log: '[INFO] Prism demo loaded',
    lua: 'local demo = "Prism"\nprint(demo)',
    mata: 'demo = 3\nprintf("Prism demo")',
    matlab: "disp('Prism demo')",
    mermaid: 'graph TD\n  Prism --> Showcase',
    mongodb: 'db.items.find({ enabled: true })',
    nasm: 'mov eax, 1\nint 0x80',
    nginx: 'server {\n  listen 80;\n  server_name example.com;\n}',
    nim: 'echo "Prism demo"',
    nix: '{ demo = "Prism"; }',
    nsis: 'Name "Prism Demo"\nOutFile "demo.exe"',
    objectivec: '@implementation Demo\n- (void)run { NSLog(@"Prism demo"); }\n@end',
    ocaml: 'print_endline "Prism demo";;',
    opencl: '__kernel void demo(__global float* out) {\n  int i = get_global_id(0);\n  out[i] = 1.0f;\n}',
    openqasm: 'OPENQASM 2.0;\nqreg q[2];\nh q[0];',
    pascal: "begin\n  writeln('Prism demo');\nend.",
    perl: 'print "Prism demo\\n";',
    php: '<?php echo "Prism demo";',
    plsql: 'BEGIN\n  DBMS_OUTPUT.PUT_LINE(\'Prism demo\');\nEND;',
    processing: 'void setup() {\n  size(200, 200);\n}',
    prolog: 'demo :- write(\'Prism demo\').',
    properties: 'demo.enabled=true\ndemo.label=Prism',
    protobuf: 'message Demo {\n  string label = 1;\n}',
    pug: 'section.demo-card\n  h2 Prism Demo',
    puppet: 'notify { "Prism demo": }',
    purescript: 'main = log "Prism demo"',
    qsharp: 'operation Demo() : Unit {\n  Message("Prism demo");\n}',
    qore: 'printf("Prism demo\\n");',
    r: 'print("Prism demo")',
    racket: '(displayln "Prism demo")',
    reason: 'let demo = "Prism";',
    rego: 'package demo\nallow if input.enabled == true',
    renpy: 'label start:\n    "Prism demo"',
    rescript: 'let demo = "Prism"',
    rip: 'class Demo {\n  fn main() {\n    print("Prism demo")\n  }\n}',
    roboconf: 'facets:\n  demo-facet {\n    installer: target\n  }',
    robotframework: '*** Test Cases ***\nPrism Demo\n    Log    Prism demo',
    ruby: 'puts "Prism demo"',
    sas: 'data demo;\n  label = "Prism";\nrun;',
    scala: 'object Demo extends App {\n  println("Prism demo")\n}',
    scheme: '(display "Prism demo")',
    smali: '.class public LDemo;\n.super Ljava/lang/Object;\n\n.method public static main()V\n  .registers 1\n  const-string v0, "Prism demo"\n  return-void\n.end method',
    smalltalk: 'Transcript show: \'Prism demo\'.',
    sml: 'val demo = "Prism"',
    solution: 'Project("{FAE04EC0-301F-11D3-BF4B-00C04F79EFBC}") = "Demo", "Demo.csproj", "{12345678-1234-1234-1234-123456789ABC}"\nEndProject\nGlobal\nEndGlobal',
    'solution-file': 'Project("{FAE04EC0-301F-11D3-BF4B-00C04F79EFBC}") = "Demo", "Demo.csproj", "{12345678-1234-1234-1234-123456789ABC}"\nEndProject\nGlobal\nEndGlobal',
    solidity: 'contract Demo {\n  string public label = "Prism";\n}',
    sparql: 'SELECT ?label WHERE {\n  ?item ex:label ?label .\n}',
    'splunk-spl': 'index=main sourcetype=demo | stats count by status',
    sqf: 'hint "Prism demo";',
    squirrel: '::print("Prism demo");',
    stan: 'data {\n  int<lower=0> N;\n}\nparameters {\n  real y;\n}\nmodel {\n  y ~ normal(0, 1);\n}',
    stata: 'display "Prism demo"',
    supercollider: '"Prism demo".postln;',
    swift: 'print("Prism demo")',
    systemd: '[Unit]\nDescription=Prism Demo\n\n[Service]\nExecStart=/usr/bin/echo Prism demo',
    't4-cs': '<# var label = "Prism"; #>\n<#= label #>',
    't4-templating': '<#@ template language="C#" #>\nHello Prism',
    't4-vb': '<# Dim label = "Prism" #>\n<#= label #>',
    tap: 'TAP version 13\n1..1\nok 1 - Prism demo',
    tcl: 'puts "Prism demo"',
    tremor: 'define script demo\nscript\n  let event = {"message": "Prism demo"};\n  emit event;\nend;',
    turtle: '@prefix ex: <https://example.com/> .\nex:demo ex:label "Prism" .',
    typoscript: 'page = PAGE\npage.10 = TEXT\npage.10.value = Prism demo',
    unrealscript: 'class Demo extends Actor;\n\nvar string Label;\n\nfunction PostBeginPlay() {\n  Log("Prism demo");\n}',
    uorazor: 'if not findalias "demo"\n  sysmsg "Prism demo"',
    'visual-basic': 'Console.WriteLine("Prism demo")',
    v: 'fn main() {\n  println("Prism demo")\n}',
    vbnet: 'Console.WriteLine("Prism demo")',
    vala: 'void main () {\n  print ("Prism demo\\n");\n}',
    velocity: '#set($label = "Prism")\n$label',
    verilog: 'module demo(input wire a, output wire y);\n  assign y = a;\nendmodule',
    vhdl: 'entity demo is\nend demo;\n\narchitecture rtl of demo is\nbegin\nend rtl;',
    vim: 'set number\nsyntax on',
    'warpscript': "'Prism demo' PRINT",
    'web-idl': 'interface Demo {\n  attribute DOMString label;\n};',
    wiki: '== Prism Demo ==',
    wolfram: 'Print["Prism demo"]',
    wren: 'System.print("Prism demo")',
    xeora: '$F:Demo.Label$',
    xojo: 'System.DebugLog("Prism demo")',
    yang: 'module prism-demo {\n  namespace "https://example.com/prism";\n}'
  };
  const catalogLanguageTargets = Object.create(null);

  function slugifyFragment(value) {
    return String(value || '').replace(/[^a-z0-9_-]/gi, '-').toLowerCase();
  }

  function buildLanguageHeadingId(language, scope) {
    return `syntax-highlight-static-${scope}-language-${slugifyFragment(language.id)}`;
  }

  function createAnchorLink(id) {
    const wrapper = document.createElement('span');
    wrapper.appendChild(document.createTextNode(' '));

    const anchor = document.createElement('a');
    anchor.href = `#${id}`;
    anchor.name = id;
    anchor.className = 'anchor ignore--print';

    const icon = document.createElement('span');
    icon.className = 'font-icon--interface--link';
    anchor.appendChild(icon);

    wrapper.appendChild(anchor);
    return wrapper;
  }

  function findTocLinkByHref(href) {
    const toc = document.getElementById('toc');
    if (!toc) {
      return null;
    }

    const links = toc.querySelectorAll('a.toc__link');
    for (let index = 0; index < links.length; index += 1) {
      if (links[index].getAttribute('href') === href) {
        return links[index];
      }
    }

    return null;
  }

  function ensureTocBranch(id) {
    const href = `#${id}`;
    const tocLink = findTocLinkByHref(href);
    if (!tocLink) {
      return null;
    }

    const summary = tocLink.closest('summary');
    if (summary && summary.parentElement) {
      return summary.parentElement;
    }

    const parent = tocLink.parentElement;
    if (!parent) {
      return null;
    }

    const details = document.createElement('details');
    details.className = 'nav';
    const newSummary = document.createElement('summary');
    newSummary.appendChild(tocLink.cloneNode(true));
    details.appendChild(newSummary);
    parent.replaceChild(details, tocLink);
    return details;
  }

  function appendTocChildLink(parentId, childId, label) {
    const branch = ensureTocBranch(parentId);
    if (!branch || findTocLinkByHref(`#${childId}`)) {
      return;
    }

    const link = document.createElement('a');
    link.className = 'toc__link';
    link.href = `#${childId}`;
    link.textContent = label;
    branch.appendChild(link);
  }

  function ensureLanguageTargetByHash() {
    const headingId = String(window.location.hash || '').replace(/^#/, '');
    const target = catalogLanguageTargets[headingId];
    if (!target) {
      return;
    }

    const existingHeading = document.getElementById(headingId);
    const group = document.querySelector(`.syntax-highlight-static__language-group[data-group-key="${target.groupKey}"]`);
    if (!group) {
      return;
    }

    if (group.classList.contains('is-collapsed')) {
      setLanguageGroupExpanded(group, true, true);
    }

    requestAnimationFrame(function () {
      const resolvedHeading = existingHeading || document.getElementById(headingId);
      if (resolvedHeading) {
        resolvedHeading.scrollIntoView({ block: 'start' });
      }
    });
  }

  setupCustomClassPlugin();
  setupFilterHighlightAllPlugin();
  renderRuntimePluginDemos();
  setupLinkableLineJumpControls();

  let catalog;

  try {
    const response = await fetch(catalogUrl, { cache: 'no-store' });
    if (!response.ok) {
      throw new Error(`Failed to load ${catalogUrl}: ${response.status}`);
    }

    catalog = await response.json();
  } catch (error) {
    renderCatalogLoadError(error);
    updateThemeStatus('Unable to load theme selector catalog.');
    return;
  }

  try {
    renderThemeControls(catalog);
  } catch (error) {
    updateThemeStatus(`Theme selector error: ${formatErrorMessage(error)}`);
    console.error('Failed to initialize syntax highlight theme controls.', error);
  }

  try {
    ensureLanguageSampleOverrides(catalog.languages);
    renderSummary(catalog);
    renderFeaturedLanguages(catalog.languages);
    renderLanguageGroups(catalog.languages);
    window.addEventListener('hashchange', ensureLanguageTargetByHash);
    if (window.location.hash) {
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          ensureLanguageTargetByHash();
        });
      });
    }
  } catch (error) {
    renderCatalogRenderError(error);
  }

  function setupCustomClassPlugin() {
    if (!Prism.plugins.customClass) {
      return;
    }

    Prism.plugins.customClass.add(function (env) {
      const classes = [];

      if (env.type === 'keyword') {
        classes.push('syntax-demo-keyword');
      }

      if (env.type === 'function') {
        classes.push('syntax-demo-function');
      }

      return classes;
    });
  }

  function setupFilterHighlightAllPlugin() {
    if (!Prism.plugins.filterHighlightAll) {
      return;
    }

    Prism.plugins.filterHighlightAll.reject.add(function (env) {
      return !!env.element.closest('.syntax-highlight-static__filter-skip');
    });
  }

  function createCodeBlock(languageId, label, code, extraClasses, inlinePreface) {
    const wrapper = document.createElement('div');
    wrapper.className = 'syntax-highlight-static__language-card';

    const pre = document.createElement('pre');
    if (label) {
      pre.setAttribute('data-label', label);
    }
    if (extraClasses) {
      pre.className = extraClasses;
    }

    const codeElement = document.createElement('code');
    codeElement.className = `language-${languageId}`;
    codeElement.textContent = code;

    pre.appendChild(codeElement);
    wrapper.appendChild(pre);
    return { wrapper, pre, codeElement };
  }

  function safeHighlightElement(codeElement, context) {
    try {
      Prism.highlightElement(codeElement);
      return true;
    } catch (error) {
      reportHighlightFailure(codeElement, context, error);
      return false;
    }
  }

  function safeHighlightAllUnder(root, context) {
    try {
      Prism.highlightAllUnder(root);
      return true;
    } catch (error) {
      reportHighlightFailure(root, context, error);
      return false;
    }
  }

  function reportHighlightFailure(target, context, error) {
    const host = target && target.closest ? target.closest('.syntax-highlight-static__language-card, .example-content-render') : null;
    if (host && !host.querySelector('.syntax-highlight-static__highlight-error')) {
      const note = document.createElement('p');
      note.className = 'syntax-highlight-static__highlight-error';
      note.innerHTML = `<small>Highlight failed for <code>${escapeHTML(context)}</code>: ${escapeHTML(formatErrorMessage(error))}</small>`;
      host.appendChild(note);
    }

    console.error(`Prism highlight failed for ${context}.`, error);
  }

  function renderCatalogLoadError(error) {
    const summary = document.getElementById('syntax-highlight-static-summary');
    if (summary) {
      summary.innerHTML = `<p>Unable to load Prism catalog data.</p><pre><code class="language-text">${escapeHTML(formatErrorMessage(error))}</code></pre>`;
    }
  }

  function renderCatalogRenderError(error) {
    const summary = document.getElementById('syntax-highlight-static-summary');
    if (summary) {
      summary.insertAdjacentHTML('beforeend', `<p class="syntax-highlight-static__highlight-error"><small>Some Prism showcase demos could not render: ${escapeHTML(formatErrorMessage(error))}</small></p>`);
    }

    console.error('Failed to render the Prism syntax showcase catalog.', error);
  }

  function formatErrorMessage(error) {
    return String((error && error.message) || error || 'Unknown error');
  }

  function createLanguageHeading(language, levelTag, scope) {
    const fragment = document.createDocumentFragment();
    const title = document.createElement(levelTag);
    const headingId = buildLanguageHeadingId(language, scope);

    title.id = headingId;
    title.className = 'syntax-highlight-static__language-title';
    const counter = document.createElement('span');
    counter.className = 'counter';
    title.appendChild(counter);
    title.appendChild(document.createTextNode(language.title));
    title.appendChild(createAnchorLink(headingId));

    const meta = document.createElement('p');
    meta.className = 'syntax-highlight-static__language-id';
    meta.appendChild(document.createTextNode('class: '));

    const codeId = document.createElement('code');
    codeId.textContent = `language-${language.id}`;
    meta.appendChild(codeId);

    fragment.appendChild(title);
    fragment.appendChild(meta);

    return { fragment, headingId };
  }

  function buildLanguageSampleOverride(language) {
    const originalSample = String(language.sample || '');
    const languageId = String(language.id || '').toLowerCase();
    const title = String(language.title || '').toLowerCase();
    const normalizedSample = originalSample.trim();

    if (!sampleNeedsReplacement(languageId, title, normalizedSample)) {
      return originalSample;
    }

    if (/(^|[-])(xml|html|markup|svg|rss|atom|ssml|cshtml|aspnet|django|ejs|etlua|erb|ftl|haml|handlebars|latte|liquid|php|pug|smarty|soy|tt2|twig|uorazor|xquery)([-]|$)/.test(languageId) || /(markup|xml|html|template)/.test(title)) {
      return '<section class="demo-card">\n  <h2>Prism Demo</h2>\n  <p data-state="ready">Static showcase</p>\n</section>';
    }

    if (/(^|[-])(css|scss|sass|less|stylus)([-]|$)/.test(languageId) || /(css|style)/.test(title)) {
      return '.demo-card {\n  color: #f26d3d;\n  background: linear-gradient(90deg, #101820, #1f5f8b);\n}';
    }

    if (/(sql|graphql|cypher|promql|n1ql|sparql|powerquery|excel-formula|plsql)/.test(languageId) || /(query|sql)/.test(title)) {
      return 'SELECT id, name\nFROM demo_items\nWHERE enabled = 1;';
    }

    if (/(bash|shell|powershell|batch)/.test(languageId) || /(shell|command|powershell|batch)/.test(title)) {
      return 'echo "Prism demo"\nnpm run build';
    }

    if (/(json|yaml|toml|ini|config|properties|editorconfig)/.test(languageId) || /(config|json|yaml|toml|ini)/.test(title)) {
      return 'demo:\n  enabled: true\n  label: Prism';
    }

    if (/(markdown|asciidoc|textile|wiki|bbcode)/.test(languageId) || /(markdown|wiki|documentation)/.test(title)) {
      return '# Prism Demo\n- static example\n- full catalog';
    }

    if (/(^|[-])(javascript|typescript|jsx|tsx|flow|jsdoc|js-extras|js-templates)([-]|$)/.test(languageId) || /(javascript|typescript)/.test(title)) {
      return 'const demo = (value) => value?.trim() ?? "fallback";\nconsole.log(demo(" Prism "));';
    }

    if (/(^|[-])(c)([-]|$)/.test(languageId)) {
      return 'for (int i = 0; i < 3; i++) {\n  printf("Prism demo\\n");\n}';
    }

    if (/(^|[-])(cpp)([-]|$)/.test(languageId) || /(c\+\+)/.test(title)) {
      return '#include <iostream>\nint main() {\n  std::cout << "Prism demo\\n";\n  return 0;\n}';
    }

    if (/(^|[-])(csharp|dotnet)([-]|$)/.test(languageId) || /(c#|dotnet)/.test(title)) {
      return 'using System;\nConsole.WriteLine("Prism demo");';
    }

    if (/(^|[-])(kotlin)([-]|$)/.test(languageId)) {
      return 'fun main() {\n  println("Prism demo")\n}';
    }

    if (/(^|[-])(arduino)([-]|$)/.test(languageId)) {
      return 'void setup() {\n  Serial.begin(9600);\n  Serial.println("Prism demo");\n}\n\nvoid loop() {}';
    }

    if (/(^|[-])(go)([-]|$)/.test(languageId)) {
      return 'package main\n\nimport "fmt"\n\nfunc main() {\n  fmt.Println("Prism demo")\n}';
    }

    if (/(^|[-])(rust)([-]|$)/.test(languageId)) {
      return 'fn main() {\n  println!("Prism demo");\n}';
    }

    if (/(^|[-])(diff)([-]|$)/.test(languageId) || /(diff|patch)/.test(title)) {
      return '@@ -1,3 +1,3 @@\n-const title = "old";\n+const title = "Prism demo";';
    }

    if (/(^|[-])(csv)([-]|$)/.test(languageId) || /(comma|csv)/.test(title)) {
      return 'id,label,enabled\n1,"Prism demo",true';
    }

    if (/(^|[-])(regex)([-]|$)/.test(languageId) || /(regex|regular expression)/.test(title)) {
      return '^(?:prism|demo)\\s+[a-z]+$';
    }

    if (/(^|[-])(git)([-]|$)/.test(languageId) || /(git)/.test(title)) {
      return '[core]\n  autocrlf = input\n[user]\n  name = Prism Demo';
    }

    return buildGenericLanguageFallback(languageId, title, originalSample);
  }

  function buildGenericLanguageFallback(languageId, title, originalSample) {
    if (!sampleNeedsReplacement(languageId, title, String(originalSample || '').trim())) {
      return originalSample;
    }

    if (/(markdown|asciidoc|textile|wiki|documentation)/.test(`${languageId} ${title}`)) {
      return '# Prism Demo\n- language-specific fallback';
    }

    if (/(html|xml|markup|template|svg|ssml|xquery|xslt)/.test(`${languageId} ${title}`)) {
      return '<demo data-label="prism">Prism showcase</demo>';
    }

    if (/(css|sass|scss|less|stylus)/.test(`${languageId} ${title}`)) {
      return '.prism-demo {\n  color: #f26d3d;\n}';
    }

    if (/(sql|query|graphql|sparql|cypher|promql|n1ql|powerquery)/.test(`${languageId} ${title}`)) {
      return 'SELECT "Prism demo" AS label;';
    }

    if (/(yaml|toml|ini|config|properties|editorconfig|apacheconf|docker|makefile|keepalived)/.test(`${languageId} ${title}`)) {
      return 'demo_enabled = true\nlabel = "Prism"';
    }

    if (/(bash|shell|powershell|batch|cmd|session)/.test(`${languageId} ${title}`)) {
      return 'echo "Prism demo"';
    }

    if (/(python|ruby|perl|php|lua|nim|v|vala|swift|dart|julia|r|matlab|octave|pascal|fortran|tcl|groovy|scala|haskell|elixir|erlang)/.test(`${languageId} ${title}`)) {
      return 'print("Prism demo")';
    }

    if (/(json|json5|jsonp)/.test(`${languageId} ${title}`)) {
      return '{\n  "label": "Prism demo"\n}';
    }

    if (/(lisp|scheme|clojure|racket)/.test(`${languageId} ${title}`)) {
      return '(display "Prism demo")';
    }

    if (/(log|stacktrace|trace)/.test(`${languageId} ${title}`)) {
      return '[INFO] Prism demo event';
    }

    return `// Prism demo (${languageId || 'unknown-language'})`;
  }

  function ensureLanguageSampleOverrides(languages) {
    languages.forEach((language) => {
      const languageId = String((language && language.id) || '').toLowerCase();
      if (!languageId) {
        return;
      }

      if (Object.prototype.hasOwnProperty.call(languageSampleOverrides, languageId) && languageSampleOverrides[languageId]) {
        languageSampleOverrides[languageId] = String(languageSampleOverrides[languageId]);
        return;
      }

      languageSampleOverrides[languageId] = buildLanguageSampleOverride(language);
    });
  }

  function getLanguageSample(language) {
    const languageId = String((language && language.id) || '').toLowerCase();
    if (!languageId) {
      return String((language && language.sample) || '');
    }

    if (!Object.prototype.hasOwnProperty.call(languageSampleOverrides, languageId)) {
      languageSampleOverrides[languageId] = buildLanguageSampleOverride(language);
    }

    return languageSampleOverrides[languageId];
  }

  function sampleNeedsReplacement(languageId, title, sample) {
    if (!sample) {
      return true;
    }

    if (genericLanguageSamples.has(sample)) {
      return true;
    }

    if (sample === '<section class="demo-card">\n  <h2>Prism Demo</h2>\n  <p data-state="ready">Static showcase</p>\n</section>' &&
      !/(^|[-])(xml|html|markup|svg|rss|atom|ssml|cshtml|aspnet|django|ejs|etlua|erb|ftl|haml|handlebars|latte|liquid|php|pug|smarty|soy|tt2|twig|uorazor|xquery)([-]|$)/.test(languageId)) {
      return true;
    }

    if (sample.indexOf('const demo = (value) =>') !== -1 && !/(javascript|typescript|jsx|tsx|flow|actionscript)/.test(languageId)) {
      return true;
    }

    if (sample.indexOf('printf("Prism demo') !== -1 && !/(^|[-])(c|cpp|clike|cilkc|cilkcpp|d|dart|go|java|kotlin|scala|groovy|glsl|hlsl|sqf|vala|v)([-]|$)/.test(languageId)) {
      return true;
    }

    if (sample.indexOf('def demo(value)') !== -1 && !/(ruby|crystal)/.test(languageId)) {
      return true;
    }

    if (sample === 'enabled = true\nmode = full\nlabel = demo') {
      return true;
    }

    if (/^(name|demo): /m.test(sample) && /(json|yaml|toml|ini|properties|tap)/.test(languageId) === false && /(config|yaml|json|toml|ini)/.test(title) === false) {
      return true;
    }

    return false;
  }

  function renderSummary(catalog) {
    const summary = document.getElementById('syntax-highlight-static-summary');
    const themes = document.getElementById('syntax-highlight-static-themes');
    const plugins = document.getElementById('syntax-highlight-static-plugins');
    const languages = document.getElementById('syntax-highlight-static-languages');

    if (summary) {
      summary.innerHTML = `<p><strong>${catalog.themes.length}</strong> themes, <strong>${catalog.plugins.length}</strong> plugins, and <strong>${catalog.languages.length}</strong> languages are configured for this Prism showcase.</p>`;
    }

    if (themes) {
      themes.innerHTML = `<ol class="syntax-highlight-static__theme-list">${catalog.themes.map((theme) => `<li><code>${escapeHTML(theme.id)}</code> - ${escapeHTML(theme.title)}</li>`).join('')}</ol>`;
    }

    if (plugins) {
      plugins.innerHTML = `<ol class="syntax-highlight-static__plugin-list">${catalog.plugins.map((plugin) => `<li><code>${escapeHTML(plugin.id)}</code> - ${escapeHTML(plugin.title)}</li>`).join('')}</ol>`;
    }

    if (languages) {
      languages.innerHTML = `<p class="syntax-highlight-static__language-meta">Configured IDs are loaded lazily by group. The catalog data is generated from the installed Prism package, not from a manually curated page list.</p>`;
    }
  }

  function renderThemeControls(catalog) {
    const select = document.getElementById('syntax-highlight-static-theme-select');
    if (!select) {
      return;
    }

    const themeOptions = catalog.themes.slice();
    const selectedThemeId = getStoredThemeId(themeOptions);

    select.innerHTML = themeOptions.map((theme) => {
      const selectedAttribute = theme.id === selectedThemeId ? ' selected' : '';
      return `<option value="${escapeHTML(theme.id)}"${selectedAttribute}>${escapeHTML(theme.title)} (${escapeHTML(theme.id)})</option>`;
    }).join('');

    applyTheme(selectedThemeId, themeOptions);

    select.addEventListener('change', function () {
      applyTheme(select.value, themeOptions);
    });
  }

  function renderFeaturedLanguages(allLanguages) {
    const root = document.getElementById('syntax-highlight-static-featured');
    if (!root) {
      return;
    }

    const featured = featuredLanguageIds
      .map((id) => allLanguages.find((language) => language.id === id))
      .filter(Boolean);

    featured.forEach((language) => {
      const column = document.createElement('div');
      column.className = 'col-default-12 col-tablet-6 col-desktop-small-4';
      const { wrapper, codeElement } = createCodeBlock(language.id, `${language.id}.demo`, getLanguageSample(language), 'line-numbers');
      const { fragment, headingId } = createLanguageHeading(language, 'h3', 'featured');
      wrapper.prepend(fragment);
      wrapper.setAttribute('aria-labelledby', headingId);
      column.appendChild(wrapper);
      root.appendChild(column);
      appendTocChildLink(featuredLanguagesTocId, headingId, language.title);
      safeHighlightElement(codeElement, language.id);
    });
  }

  function renderLanguageGroups(allLanguages) {
    const root = document.getElementById('syntax-highlight-static-language-groups');
    if (!root) {
      return;
    }
    root.classList.remove('is-ready');
    const fragment = document.createDocumentFragment();

    const groups = allLanguages.reduce((accumulator, language) => {
      const groupKey = /^[A-Z]$/.test(language.group) ? language.group : '#';
      accumulator[groupKey] = accumulator[groupKey] || [];
      accumulator[groupKey].push(language);
      return accumulator;
    }, {});

    Object.keys(groups).sort().forEach((groupKey) => {
      const group = document.createElement('div');
      group.className = 'syntax-highlight-static__language-group is-collapsed';
      group.dataset.groupKey = groupKey;

      const toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.className = 'syntax-highlight-static__language-group-toggle';
      toggle.setAttribute('aria-expanded', 'false');
      toggle.setAttribute('aria-controls', `syntax-highlight-static-group-${slugifyFragment(groupKey)}`);
      toggle.textContent = `${groupKey} (${groups[groupKey].length})`;

      const panel = document.createElement('div');
      panel.className = 'syntax-highlight-static__language-group-panel';
      panel.id = `syntax-highlight-static-group-${slugifyFragment(groupKey)}`;
      if ('inert' in panel) {
        panel.inert = true;
      }

      const grid = document.createElement('div');
      grid.className = 'row';

      panel.appendChild(grid);
      group.appendChild(toggle);
      group.appendChild(panel);

      groups[groupKey].forEach((language) => {
        const column = document.createElement('div');
        column.className = 'col-default-12 col-tablet-6 col-desktop-small-4';

        const card = document.createElement('article');
        card.className = 'syntax-highlight-static__language-card';

        const { fragment, headingId } = createLanguageHeading(language, 'h3', 'catalog');
        card.setAttribute('aria-labelledby', headingId);
        card.appendChild(fragment);

        const sampleHost = document.createElement('div');
        sampleHost.className = 'syntax-highlight-static__language-sample-host';
        sampleHost.dataset.languageId = language.id;
        sampleHost.dataset.languageTitle = language.title;
        card.appendChild(sampleHost);

        column.appendChild(card);
        grid.appendChild(column);

        catalogLanguageTargets[headingId] = { groupKey, languageId: language.id };
        appendTocChildLink(fullCatalogTocId, headingId, language.title);
      });

      toggle.addEventListener('click', function handleClick() {
        setLanguageGroupExpanded(group, group.classList.contains('is-collapsed'), false);
      });

      fragment.appendChild(group);
    });

    root.appendChild(fragment);
    root.classList.add('is-ready');
  }

  function setLanguageGroupExpanded(group, shouldExpand, scrollToHashTarget) {
    const toggle = group.querySelector('.syntax-highlight-static__language-group-toggle');
    const panel = group.querySelector('.syntax-highlight-static__language-group-panel');

    if (!toggle || !panel) {
      return;
    }

    if (shouldExpand && group.dataset.loaded !== 'true') {
      loadLanguageGroupSamples(group);
      group.dataset.loaded = 'true';
    }

    group.classList.toggle('is-collapsed', !shouldExpand);
    toggle.setAttribute('aria-expanded', shouldExpand ? 'true' : 'false');

    if ('inert' in panel) {
      panel.inert = !shouldExpand;
    }

    if (shouldExpand && scrollToHashTarget) {
      ensureLanguageTargetByHash();
    }
  }

  function loadLanguageGroupSamples(group) {
    const sampleHosts = group.querySelectorAll('.syntax-highlight-static__language-sample-host');
    sampleHosts.forEach((sampleHost) => {
      if (sampleHost.dataset.loaded === 'true') {
        return;
      }

      const languageId = sampleHost.dataset.languageId || '';
      const language = {
        id: languageId,
        title: sampleHost.dataset.languageTitle || ''
      };
      const { pre, codeElement } = createCodeBlock(languageId, `${languageId}.demo`, getLanguageSample(language), '');
      sampleHost.appendChild(pre);
      sampleHost.dataset.loaded = 'true';
      safeHighlightElement(codeElement, languageId);
    });
  }

  function renderRuntimePluginDemos() {
    renderCustomClassDemo();
    renderFilterHighlightAllDemo();
    renderAutoloaderDemo();
  }

  function renderCustomClassDemo() {
    const root = document.getElementById('syntax-highlight-static-custom-class');
    if (!root) {
      return;
    }

    const { wrapper, codeElement } = createCodeBlock(
      'javascript',
      'custom-class-demo.js',
      'function decorate(value) {\n  if (!value) {\n    return null;\n  }\n\n  return value.trim();\n}',
      ''
    );

    root.appendChild(wrapper);
    safeHighlightElement(codeElement, 'custom-class-demo');
  }

  function renderFilterHighlightAllDemo() {
    const root = document.getElementById('syntax-highlight-static-filter-highlight-all');
    if (!root) {
      return;
    }

    const container = document.createElement('div');
    container.className = 'row';

    const keepColumn = document.createElement('div');
    keepColumn.className = 'col-default-12 col-desktop-small-6';
    keepColumn.innerHTML = '<h4>Allowed</h4>';
    const keepBlock = createCodeBlock('css', 'filter-allowed.css', '.allowed-demo {\n  color: #f26d3d;\n}', '');
    keepColumn.appendChild(keepBlock.pre);

    const skipColumn = document.createElement('div');
    skipColumn.className = 'col-default-12 col-desktop-small-6 syntax-highlight-static__filter-skip';
    skipColumn.innerHTML = '<h4>Rejected</h4>';
    const skipBlock = createCodeBlock('css', 'filter-rejected.css', '.rejected-demo {\n  color: #4bc6b9;\n}', '');
    skipColumn.appendChild(skipBlock.pre);

    container.appendChild(keepColumn);
    container.appendChild(skipColumn);
    root.appendChild(container);

    safeHighlightAllUnder(container, 'filter-highlight-all-demo');
  }

  function renderAutoloaderDemo() {
    const root = document.getElementById('syntax-highlight-static-autoloader');
    if (!root) {
      return;
    }

    const { wrapper, codeElement } = createCodeBlock(
      'rego',
      'autoloaded-policy.rego',
      'package demo\n\nallow if {\n  input.build == "ready"\n  input.highlight == true\n}',
      ''
    );

    root.appendChild(wrapper);
    safeHighlightElement(codeElement, 'autoloader-demo');
  }

  function setupLinkableLineJumpControls() {
    const form = document.getElementById('syntax-linkable-lines-form');
    const input = document.getElementById('syntax-linkable-lines-input');
    const status = document.getElementById('syntax-linkable-lines-status');
    if (!form || !input) {
      return;
    }

    const updateInputFromHash = function () {
      const match = window.location.hash.match(/^#syntax-linkable-lines\.(\d+)$/);
      if (!match) {
        return;
      }

      const value = Number.parseInt(match[1], 10);
      if (Number.isFinite(value) && value > 0) {
        input.value = String(value);
      }
    };

    const setStatus = function (message) {
      if (!status) {
        return;
      }

      status.textContent = message;
      status.hidden = !message;
    };

    const jumpToLine = function (lineNumber) {
      const hash = `#syntax-linkable-lines.${lineNumber}`;
      if (window.location.hash === hash) {
        const pre = document.getElementById('syntax-linkable-lines');
        if (pre) {
          pre.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        setStatus(`Already at ${hash}.`);
        return;
      }

      window.location.hash = hash;
      setStatus(`Navigated to ${hash}.`);
    };

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      const value = Number.parseInt(String(input.value || ''), 10);
      if (!Number.isFinite(value) || value < 1) {
        setStatus('Enter a line number greater than or equal to 1.');
        input.focus();
        return;
      }

      jumpToLine(value);
    });

    window.addEventListener('hashchange', updateInputFromHash);
    updateInputFromHash();
  }

  function getStoredThemeId(themeOptions) {
    const availableThemeIds = themeOptions.map((theme) => theme.id);

    try {
      const storedThemeId = window.localStorage.getItem(themeStorageKey);
      if (storedThemeId && availableThemeIds.indexOf(storedThemeId) !== -1) {
        return storedThemeId;
      }
    } catch (error) {
      // Ignore storage access failures and fall back to the default theme.
    }

    if (availableThemeIds.indexOf(defaultThemeId) !== -1) {
      return defaultThemeId;
    }

    return availableThemeIds[0] || defaultThemeId;
  }

  function applyTheme(themeId, themeOptions) {
    const selectedTheme = themeOptions.find((theme) => theme.id === themeId) || themeOptions[0];
    if (!selectedTheme) {
      updateThemeStatus('No Prism themes are available for selection.');
      return;
    }

    const themeLink = ensureThemeStylesheet();
    themeLink.dataset.themeId = selectedTheme.id;
    themeLink.href = `/asset/css/module/prism/theme/${selectedTheme.id}.min.css`;
    clearThemeStatus();

    const select = document.getElementById('syntax-highlight-static-theme-select');
    if (select && select.value !== selectedTheme.id) {
      select.value = selectedTheme.id;
    }

    try {
      window.localStorage.setItem(themeStorageKey, selectedTheme.id);
    } catch (error) {
      // Ignore storage access failures; the page still works without persistence.
    }

  }

  function ensureThemeStylesheet() {
    let themeLink = document.getElementById('syntax-highlight-static-theme-link');

    if (!themeLink) {
      themeLink = document.createElement('link');
      themeLink.id = 'syntax-highlight-static-theme-link';
      themeLink.rel = 'stylesheet';
      themeLink.addEventListener('load', function () {
        clearThemeStatus();
      });
      themeLink.addEventListener('error', function () {
        const activeThemeId = themeLink.dataset.themeId || 'unknown';
        updateThemeStatus(`Theme stylesheet failed to load: ${activeThemeId}`);
      });
      document.head.appendChild(themeLink);
    }

    return themeLink;
  }

  function updateThemeStatus(message) {
    const status = document.getElementById('syntax-highlight-static-theme-status');
    const statusLine = document.getElementById('syntax-highlight-static-theme-status-line');
    if (status) {
      status.textContent = message;
    }
    if (statusLine) {
      statusLine.hidden = !message;
    }
  }

  function clearThemeStatus() {
    updateThemeStatus('');
  }

  function escapeHTML(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;')
      .replace(/\//g, '&#x2F;')
      .replace(/@/g, '&#64;');
  }
});
